import '@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import '@progress/kendo-theme-default/dist/all.css';
import '@progress/kendo-ui'
import '@common/kendo-ui-license.js'
import "../Styles/Colors.css";
import "../Styles/KendoUI.css";
import "../Styles/Layout.css";
import "../Styles/Switch.css";

import Vue from "vue";
import router from './router';
import { sanitizeUrl } from "@braintree/sanitize-url";
import JsonViewer from 'vue-json-viewer';

import '@browser/Browser';
import { appRT } from '@common/AppRT';
import { connect } from "../../../_Workflows/connection";

Vue.use(JsonViewer) 

Vue.directive('sanitizedHref', {
    bind: function (el: HTMLAnchorElement | HTMLLinkElement, binding: any) {
        el.href = sanitizeUrl(binding.value);
    }
});

connect(conn => {
    appRT(conn);
    new Vue({ router }).$mount("#app");
});